import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  const toggleFaq = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-500">快速答疑 · 了解更多</p>
        </div>
        <div className="space-y-3">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(faq.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm font-semibold text-foreground-900 pr-4">{faq.question}</h3>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full bg-background-200 flex-shrink-0 transition-transform duration-200 ${openId === faq.id ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500 text-sm"></i>
                </div>
              </button>
              {openId === faq.id && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}